import { useEffect, useRef, useCallback } from 'react';

/**
 * Hook personalizado para implementar infinite scroll
 * @param {Function} callback - Función a ejecutar cuando se llega al final
 * @param {boolean} hasMore - Si hay más datos para cargar
 * @param {boolean} loading - Si está cargando actualmente
 * @param {number} threshold - Distancia en px desde el final para activar (default: 300)
 */
const useInfiniteScroll = (callback, hasMore, loading, threshold = 300) => {
  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          callback();
        }
      }, {
        rootMargin: `${threshold}px`
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore, callback, threshold]
  );

  return lastElementRef;
};

export default useInfiniteScroll;
